import React from 'react';
import './Testimonials.css';

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      name: 'Priya Sharma',
      location: 'Ayodhya, UP',
      quote: 'The purest milk we\'ve ever tasted! Our family has been loyal customers for 5 years.',
      avatar: '/images/testimonials/user1.jpg'
    },
    {
      id: 2,
      name: 'Rajesh Kumar',
      location: 'Lucknow, UP',
      quote: 'Ayodhya Dairy\'s ghee brings back childhood memories. Authentic taste, premium quality.',
      avatar: '/images/testimonials/user2.jpg'
    },
    {
      id: 3,
      name: 'Anita Singh',
      location: 'Varanasi, UP',
      quote: 'Fresh curd delivered daily. My kids love it, and I trust the quality completely.',
      avatar: '/images/testimonials/user3.jpg'
    },
    {
      id: 4,
      name: 'Vikram Patel',
      location: 'Kanpur, UP',
      quote: 'Best dairy products in the region. The traditional methods make all the difference.',
      avatar: '/images/testimonials/user4.jpg'
    },
    {
      id: 5,
      name: 'Sunita Devi',
      location: 'Allahabad, UP',
      quote: 'Pure, natural, and delicious. Ayodhya Dairy has become a part of our daily routine.',
      avatar: '/images/testimonials/user5.jpg'
    },
    {
      id: 6,
      name: 'Amit Verma',
      location: 'Gorakhpur, UP',
      quote: 'Excellent service and quality. The buttermilk is perfect for hot summer days!',
      avatar: '/images/testimonials/user6.jpg'
    }
  ];

  return (
    <section id="testimonials" className="testimonials">
      <div className="testimonials-container">
        <div className="testimonials-header">
          <h2 className="section-title">Trusted by Families</h2>
          <p className="section-subtitle">
            Hear what our customers say about their experience with Ayodhya Dairy.
          </p>
        </div>
        <div className="testimonials-grid">
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="testimonial-card">
              <div className="testimonial-stars">
                <span className="star">⭐</span>
                <span className="star">⭐</span>
                <span className="star">⭐</span>
                <span className="star">⭐</span>
                <span className="star">⭐</span>
              </div>
              <p className="testimonial-quote">"{testimonial.quote}"</p>
              <div className="testimonial-author">
                <div className="testimonial-avatar">
                  <img src={testimonial.avatar} alt={testimonial.name} />
                </div>
                <div className="testimonial-info">
                  <div className="testimonial-name">{testimonial.name}</div>
                  <div className="testimonial-location">{testimonial.location}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;

